import React from 'react';
import { Phone, Check } from 'lucide-react';
import { businessData } from '../mock';

const Prices = () => {
  return (
    <div className="page-prices">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Priser</h1>
          <p className="page-subtitle">
            Enkel, fair prissætning for klassisk kvalitet
          </p>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="pricing-container">
          <div className="pricing-card-main">
            <div className="pricing-header">
              <h2 className="pricing-service-name">Herreklip</h2>
              <p className="pricing-description">
                Professionel klipning med saks og maskine
              </p>
            </div>
            <div className="pricing-amount-wrapper">
              <span className="pricing-amount">170 kr.</span>
              <span className="pricing-note">ca. pris</span>
            </div>
            <div className="pricing-features">
              <div className="pricing-feature">
                <Check size={20} />
                <span>Klassisk herreklip</span>
              </div>
              <div className="pricing-feature">
                <Check size={20} />
                <span>Saks og maskine</span>
              </div>
              <div className="pricing-feature">
                <Check size={20} />
                <span>Over 50 års erfaring</span>
              </div>
              <div className="pricing-feature">
                <Check size={20} />
                <span>Personlig service</span>
              </div>
              <div className="pricing-feature">
                <Check size={20} />
                <span>Ingen tidsbegrænsning</span>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          <div className="pricing-info-grid">
            <div className="pricing-info-card">
              <h3 className="pricing-info-title">Kvalitet frem for hastværk</h3>
              <p className="pricing-info-text">
                Vi tager os tid til hver eneste kunde. Ingen masseproduktion,
                ingen hastværk – bare klassisk håndværk udført med omhu.
              </p>
            </div>
            <div className="pricing-info-card">
              <h3 className="pricing-info-title">Book din tid</h3>
              <p className="pricing-info-text">
                Ring til os på telefonen for at aftale en tid.
                Vi har ingen online booking – personlig kontakt er en del af
                oplevelsen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="pricing-image-section">
        <div className="pricing-image-wrapper">
          <img
            src={businessData.images.tools}
            alt="Klassiske barbering værktøjer"
            className="pricing-image"
          />
        </div>
      </section>

      {/* CTA */}
      <section className="pricing-cta-section">
        <div className="pricing-cta-container">
          <h2 className="pricing-cta-title">Klar til klassisk klipning?</h2>
          <p className="pricing-cta-text">
            Ring til os i dag for at booke en tid
          </p>
          <a href={`tel:${businessData.phone}`} className="cta-button">
            <Phone size={20} />
            {businessData.phone}
          </a>
          <p className="pricing-cta-hours">
            Åbent man, tir, tor, fre: 10.30–17.30
          </p>
        </div>
      </section>
    </div>
  );
};

export default Prices;